import { useCallback, useRef } from 'react';
import type { GoodsCoreModel, IScreensLogging } from '../../../../../api/types';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';
import { useLogAnalyticsEvent } from '../../../../../hooks';

type LogOnGoodsPressItemParams = {
  logging: IScreensLogging;
  item: GoodsCoreModel;
};

export const useLogOnGoodsPressItem = () => {
  const screen = useAtomicScreen();

  // bridge 직접 호출 대신 AnalyticsContext 자동 머지 wrapper 사용.
  // AnalyticsScreen이 주입한 SCREEN 등 공용 logging 필드가 누락되던 문제 해결.
  // emitForViewable이 ref만 참조하도록 ref 동기화 (외부 useCallback/useEffect deps 안정성 유지).
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const logAnalyticsEventRef = useRef(logAnalyticsEvent);
  logAnalyticsEventRef.current = logAnalyticsEvent;

  return useCallback(
    ({ logging, item }: LogOnGoodsPressItemParams) => {
      logAnalyticsEventRef.current({
        channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
        name: 'CLICK_GOODS',
        analytics: {
          ...logging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: logging.ably_only_log,
      });
      if (isNotNil(item.ad)) {
        bridge.logAdEvent({ action: AdAction.CLICK, ad: item.ad });
      }
    },
    [screen],
  );
};
